<div class="toast-container">
  <div @scaleFadeIn *ngFor="let item of items;">
    <alert [item]="item" (hide)="onHide($event)"></alert>
  </div>
</div>
